import {request} from "./request";

export const getUserAvatar = queryParams => {
  return request.get({
    path: "/engine/user/avatar/info",
    queryParams,
  });
};

export const getUserAvatarList = queryParams => {
  return request.get({
    path: "/engine/user/avatar/list",
    queryParams,
  });
};

export const createUserAvatar = params => {
  return request.post({
    path: "/engine/user/avatar/create", //doesn't exist in DB
    params,
  });
};
